export default "__VITE_ASSET__GVJmUO_r__"